import { Spin } from 'antd';
import React from 'react';

interface MapLoaderProps {
    style?: React.CSSProperties;
    message?: string;
}

const baseStyle: React.CSSProperties = {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 12,
    background: '#f5f5f5',
    color: '#757575',
    fontSize: 13,
};

const MapLoader = ({ style, message = 'Cargando mapa...' }: MapLoaderProps) => (
    <div style={{ ...baseStyle, ...style }}>
        <Spin />
        <span>{message}</span>
    </div>
);

export default MapLoader;
